<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Aguarde ...</p>
</ngx-spinner>

<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <div class="card participantes-card">
        <div class="card-header d-flex justify-content-between align-items-center">
          <h4 class="card-title mb-0">
            <i class="feather icon-users me-3"></i>
            &nbsp; &nbsp; Participantes por Etapa Atual
          </h4>
        </div>
        <div class="card-body">
          <div class="filters-section mb-4">
            <div class="row align-items-center mb-3">
              <div class="col-md-4">
                <div class="form-group">
                  <label for="triagemSelect" class="form-label">Selecione o Programa</label>
                  <select
                    class="form-select custom-select"
                    id="triagemSelect"
                    [(ngModel)]="selectedTriagem"
                    (change)="onTriagemChange()"
                  >
                    <option *ngFor="let triagem of triagens" [ngValue]="triagem.id">
                      {{ triagem.titulo }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-8 text-end">
                <div class="export-button-wrapper mb-2">
                  <button
                    type="button"
                    class="btn btn-primary export-btn"
                    (click)="exportarRespostasPrograma()"
                  >
                    <i class="feather icon-download me-2"></i>
                    Exportar Respostas
                  </button>
                </div>
                <div class="counters">
                  <span class="badge bg-teal me-2">
                    <i class="feather icon-users me-1"></i>
                    {{ filteredParticipantes.length }} participantes
                  </span>
                  <span class="badge bg-teal-light">
                    <i class="feather icon-filter me-1"></i>
                    {{ searchText ? "Filtrado" : "Todos" }}
                  </span>
                </div>
              </div>
            </div>

            <div class="row align-items-center">
              <div class="col-md-6">
                <div class="search-box">
                  <i class="feather icon-search"></i>
                  <input
                    type="text"
                    class="form-control"
                    [(ngModel)]="searchText"
                    (input)="onSearch()"
                    placeholder="Pesquisar participante, responsável, grupo, etapa..."
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="table-responsive participantes-table">
            <table class="table table-hover">
              <thead class="table-light">
                <tr>
                  <th class="col-1">Grupo</th>
                  <th class="col-2">Responsável</th>
                  <th class="col-2">Criança</th>
                  <th class="col-1">Sexo</th>
                  <th class="col-2">Etapa Atual</th>
                  <th class="col-2">Módulo Atual</th>
                  <th class="col-2">Atividade Atual</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let participante of filteredParticipantes">
                  <td>
                    <span class="grupo-badge" [ngClass]="getGrupoCssClass(participante.grupo)">
                      {{ participante.grupo }}
                    </span>
                  </td>
                  <td class="text-truncate">{{ participante.nomeResponsavel }}</td>
                  <td class="text-truncate">{{ participante.nomeCrianca }}</td>
                  <td>{{ participante.sexoCrianca }}</td>
                  <td class="text-truncate">{{ participante.atividadeAtual?.etapa || "-" }}</td>
                  <td class="text-truncate">{{ participante.atividadeAtual?.modulo || "-" }}</td>
                  <td class="text-truncate">{{ participante.atividadeAtual?.atividade || "-" }}</td>
                </tr>
                <tr *ngIf="filteredParticipantes.length === 0">
                  <td colspan="7" class="text-center text-muted py-4">
                    Nenhum participante encontrado para o filtro selecionado.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
